<template>
  <b-card
    v-if="data"
    no-body
    class="card-revenue-budget"
  >
    <b-row class="mx-0">
      <b-col
        class="revenue-report-wrapper"
      >
        <div class="d-sm-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-50 mb-sm-0">
            Évolution des Dépenses <b>( {{ amountToCurrency(expensesTotal) }} )</b>
          </h4>
        </div>

        <!-- chart -->
        <vue-apex-charts
          id="expenses-trend-chart"
          type="line"
          height="280"
          :options="expensesTrend.chartOptions"
          :series="data.series"
        />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import { amountToCurrency } from "@/utils/formatAmount";

export default {
  name: "StatisticExpensesTrend",
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
  },
  directives: {
    Ripple,
  },
  props: {
    expensesTotal: {
      type: Number,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expensesTrend: {
        chartOptions: {
          chart: {
            type: 'line',
            toolbar: {
              show: true,
              tools: {
                download: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
              }
            },
            // zoom: {
            //   enabled: true
            // }
          },
          stroke: {
            width: 3,
            curve: 'smooth'
          },
          markers: {
            size: 5,
            hover: {
              size: 7
            }
          },
          grid: {
            borderColor: '#e7e7e7',
            row: {
              colors: ['#f3f3f3', 'transparent'],
              opacity: 0.5
            },
          },
          xaxis: {
            categories: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Jul', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc'],
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
            },
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: true,
              color: '#e7e7e7'
            },
          },
          legend: {
            show: true,
            position: 'top',
            horizontalAlign: 'left',
            fontSize: '14px',
            fontFamily: 'Montserrat',
            markers: {
              width: 10,
              height: 10,
              radius: 12,
            },
            itemMargin: {
              horizontal: 10,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: [$themeColors.primary, $themeColors.warning, $themeColors.info],
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function (value) {
                return amountToCurrency(value)
              }
            }
          },
          yaxis: {
            labels: {
              style: {
                colors: '#6E6B7B',
                fontSize: '0.86rem',
                fontFamily: 'Montserrat',
              },
              formatter: function (value) {
                return amountToCurrency(value)
              }
            },
          },
        },
      },
    }
  },
  methods: {
    amountToCurrency,
  },
}
</script>
